import { activeGameId } from "../../util/selectors";
import { getSafe } from "../../util/storeHelper";
import * as path from "path";
import { getGame } from "../gamemode_management/util/getGame";
import getInstallPath from "./util/getInstallPath";
import { createCachedSelector } from "re-reselect";
import { createSelector } from "reselect";
const installPathPattern = (state) => state.settings.mods.installPath;
const gameInstallPathPattern = (state, gameId) => state.settings.mods.installPath[gameId];
const activators = (state) => state.settings.mods.activator;
const allNeedToDeploy = (state) => state.persistent.deployment.needToDeploy;
export const installPath = createSelector(installPathPattern, activeGameId, (inPaths, inGameMode) => {
    if (inGameMode === undefined) {
        return undefined;
    }
    return getInstallPath(inPaths[inGameMode], inGameMode);
});
export const installPathForGame = createCachedSelector(gameInstallPathPattern, (state, gameId) => gameId, (inPath, gameId) => gameId !== undefined ? getInstallPath(inPath, gameId) : undefined)((state, gameId) => {
    if (gameId === undefined) {
        return undefined;
    }
    return gameId;
});
export const currentActivator = createSelector(activators, activeGameId, (inActivators, inGameMode) => {
    return inActivators[inGameMode];
});
export const activatorForGame = createCachedSelector(activators, (state, gameId) => gameId, (inActivators, gameId) => inActivators[gameId])((state, gameId) => {
    if (gameId === undefined) {
        throw new Error("gameId can't be undefined");
    }
    return gameId;
});
export const needToDeploy = createSelector(allNeedToDeploy, activeGameId, (inNeedToDeploy, inGameMode) => inNeedToDeploy[inGameMode]);
export const needToDeployForGame = createCachedSelector(allNeedToDeploy, (state, gameId) => gameId, (inNeedToDeploy, inGameId) => inNeedToDeploy[inGameId])((state, gameId) => gameId);
const emptyObj = {};
function discoveries(state) {
    return getSafe(state, ["settings", "gameMode", "discovered"], emptyObj);
}
export const modPathsForGame = createSelector(discoveries, (state, gameId) => gameId, (inDiscoveries, inGameId) => {
    const game = getGame(inGameId);
    const discovery = inDiscoveries[inGameId];
    if (game === undefined) {
        return undefined;
    }
    if (discovery === undefined || discovery.path === undefined) {
        return undefined;
    }
    return game.getModPaths(discovery.path);
});
export const modsForGame = (state, gameId) => {
    if (gameId === undefined) {
        return {};
    }
    return state.persistent.mods?.[gameId] || {};
};
export const modsForActiveGame = createSelector(activeGameId, (state) => state, (activeGameId, state) => {
    return modsForGame(state, activeGameId);
});
export const getMod = createSelector(modsForGame, (state, gameId, modId) => modId, (mods, modId) => {
    if (typeof modId === "number") {
        return Object.values(mods).find((mod) => mod.attributes?.modId === modId);
    }
    return mods[modId];
});
export const getModInstallPath = createSelector(getMod, (state, gameId) => installPathForGame(state, gameId), (mod, gameInstallPath) => {
    if (mod?.installationPath == null || gameInstallPath == null) {
        return undefined;
    }
    return path.join(gameInstallPath, mod.installationPath);
});
